import { render, staticRenderFns } from "./OpinionMailboxInfo.vue?vue&type=template&id=b3fb814c&scoped=true"
import script from "./OpinionMailboxInfo.vue?vue&type=script&lang=js"
export * from "./OpinionMailboxInfo.vue?vue&type=script&lang=js"
import style0 from "./OpinionMailboxInfo.vue?vue&type=style&index=0&id=b3fb814c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fb814c",
  null
  
)

export default component.exports